<nav class="sidebar-nav">
    <ul id="sidebarnav">
        <!-- User Profile-->
        <li class="sidebar-item user-profile" [class.active]="showMenu === 'user'">
            <a class="sidebar-link has-arrow waves-effect waves-dark" href="javascript:void(0)" (click)="addExpandClass('user')" aria-expanded="false"><span><img src="assets/images/users/profile.png"
                        alt="user" /></span><span class="hide-menu"><b>ADMIN / PRINCIPAL </b></span></a>
            <!-- <ul aria-expanded="false" class="collapse" [class.in]="showMenu === 'user'">
                <li>
                    <a href="javascript:void()" class="sidebar-link p-0">My Profile </a>
                </li>
                <li>
                    <a href="javascript:void()" class="sidebar-link p-0">My Balance</a>
                </li>
                <li><a href="javascript:void()" class="sidebar-link p-0">Inbox</a></li>
                <li>
                    <a href="javascript:void()" class="sidebar-link p-0">Account Setting</a>
                </li>
                <li><a href="javascript:void()" class="sidebar-link p-0">Logout</a></li>
            </ul> -->
        </li>
        <!-- First level menu -->
        <li class="sidebar-item" [class.active]="showMenu === sidebarnavItem.title" *ngFor="let sidebarnavItem of sidebarnavItems_v2" [routerLinkActive]="sidebarnavItem.submenu.length != 0 ? '' : 'active'">
            <div class="nav-small-cap" *ngIf="sidebarnavItem.extralink === true">
                <i [ngClass]="[sidebarnavItem.icon]"></i><span class="hide-menu">{{ sidebarnavItem.title }}</span>
            </div>

            <a class="sidebar-link waves-effect waves-dark" [routerLink]="sidebarnavItem.class === '' ? [sidebarnavItem.url] : null" [ngClass]="[sidebarnavItem.class]" *ngIf="!sidebarnavItem.extralink" (click)="addExpandClass(sidebarnavItem.title)" [routerLinkActive]="sidebarnavItem.submenu.length != 0 ? '' : 'active'"
                style="padding-top: 4px; padding-bottom: 0px;">
                <i [ngClass]="[sidebarnavItem.icon]"></i>
                <span class="hide-menu">{{ sidebarnavItem.title }}

                    <!-- <span
              *ngIf="sidebarnavItem.label != ''"
              [ngClass]="[sidebarnavItem.labelClass]"
              >{{ sidebarnavItem.label }}</span
            > -->

                </span>
            </a>

            <!-- Second level menu -->
            <ul aria-expanded="false" class="collapse first-level" *ngIf="sidebarnavItem.submenu.length > 0" [ngClass]="{ in: showMenu === sidebarnavItem.title }">
                <li class="sidebar-item" *ngFor="let sidebarnavSubItem of sidebarnavItem.submenu" [class.active]="showSubMenu === sidebarnavSubItem.title" [routerLinkActive]="
              sidebarnavSubItem.submenu.length > 0 ? '' : 'active'
            ">
                    <a class="sidebar-link" [routerLink]="sidebarnavSubItem.submenu.length > 0 ? null
                  : [sidebarnavSubItem.url]
              " [routerLinkActive]="sidebarnavSubItem.submenu.length > 0 ? '' : 'router-link-active'
              " [ngClass]="[sidebarnavSubItem.class]" *ngIf="!sidebarnavSubItem.extralink" (click)="addActiveClass(sidebarnavSubItem.title)" style="padding-top: 4px; padding-bottom: 0px;">

                        <i [ngClass]="[sidebarnavSubItem.icon]"></i>
                        <span class="hide-menu" style="white-space: normal;">{{ sidebarnavSubItem.title }}</span>
                    </a>
                    <!-- Third level menu -->
                    <ul aria-expanded="false" class="collapse Second-level" *ngIf="sidebarnavSubItem.submenu.length > 0" [ngClass]="{ in: showSubMenu === sidebarnavSubItem.title }" style="margin-left: 23px;">
                        <li class="sidebar-item" *ngFor="let sidebarnavSubsubItem of sidebarnavSubItem.submenu" routerLinkActive="active" [ngClass]="[sidebarnavSubsubItem.class]">
                            <a class="sidebar-link" [routerLink]="[sidebarnavSubsubItem.url]" *ngIf="!sidebarnavSubsubItem.extralink" [routerLinkActive]="
                    sidebarnavSubsubItem.submenu.length > 0 ? '' : 'router-link-active' " style="padding: 2px 22px 0 34px;;">
                                <span class="hide-menu mr-1" style="align-self: flex-start;">- </span>
                                <span class="hide-menu" style="white-space: normal;">{{
                                    sidebarnavSubsubItem.title }}</span>
                            </a>
                        </li>
                    </ul>
                </li>
            </ul>
        </li>
    </ul>
</nav>